import { Injectable } from '@angular/core';
import * as localforage from 'localforage';
import { formatBytes } from '../../core';

@Injectable({
	providedIn: 'root'
})
export class LocalStorageService {
	private store!: LocalForage;
	isPersistentStorage = false;
	storageEstimate?: StorageEstimate;

	constructor() {
		this.updateStorageInfo();
		this.createStore();
	}

	updateStorageInfo() {
		if (navigator.storage) {
			if (navigator.storage.persist) {
				navigator.storage.persist().then((isPersisted) => {
					this.isPersistentStorage = isPersisted;
				});
			}
			if (navigator.storage.estimate) {
				navigator.storage.estimate().then((estimate) => {
					this.storageEstimate = estimate;
				});
			}
		}
	}

	protected createStore() {
		this.createStoreImpl('PNGBR Storage');
	}

	protected createStoreImpl(name: string) {
		this.store = localforage.createInstance({ name: name });
	}

	get(key: string) {
		return this.store.getItem(key);
	}

	set(key: string, value: any) {
		this.updateStorageInfo();
		return this.store.setItem(key, value);
	}

	remove(key: string) {
		this.updateStorageInfo();
		return this.store.removeItem(key);
	}

	DELETE_ALL() {
		return this.store.clear();
	}

	listKeys() {
		return this.store.keys();
	}

	storageMessage() {
		if (!navigator.storage || !navigator.storage.estimate) {
			return 'Storage API not supported';
		}
		const estimate = this.storageEstimate;
		const used = estimate?.usage ?? 0;
		const quota = estimate?.quota ?? 0;
		const percent = quota > 0 ? Math.round((used / quota) * 100) : 0;
		const persistent = this.isPersistentStorage ? ' (persistent)' : ' (temporär)';
		return `${formatBytes(used)}/${formatBytes(quota)}${persistent}`;
	}
}
